import { createReducer, on } from '@ngrx/store';
import * as actions from '../actions';

export const statementsFeatureKey = 'statements';

export interface State {
  loadStatements: any;
  loadStatementsResponse: any;
  loadStatementsFailure: any;
}

export const initialState: State = {
  loadStatements: undefined,
  loadStatementsResponse: undefined,
  loadStatementsFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(actions.loadStatements, (state, { request }) => ({
    ...state,
    loadStatements: request
  })),
  on(actions.loadStatementsSuccess, (state, { response }) => ({
    ...state,
    loadStatementsResponse: response
  })),
  on(actions.loadStatementsFailure, (state, { error }) => ({
    ...state,
    loadStatementsFailure: error
  }))
);

export const getStatements = (state: State) => state.loadStatementsResponse;
